$(window).on("load", function(){
  var reviews = $(".yotpo-display-wrapper a.text-m").text();
  console.log(reviews)
  $("span.custom-products-reviews-count").text(reviews)
})
$(document).ready(function(){
  
  console.log("working");
//   $(".custom-product-reviews-items").flickity({
//   wrapAround: true,
//   pageDots: true, 
//   initialIndex: 1,
//   accessibility: true, //true by default
//   autoPlay: false // advance cells every 3 seconds
// });
  $('.pr-section-1st-design .custom-product-reviews-items').slick({
  dots: true,
  adaptiveHeight:true,
  infinite: true,
  speed: 300, 
  prevArrow:'<button type="button" class="slick-prev pull-left"><svg class="flickity-button-icon"  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="1em" height="1em" fill="currentColor" role="presentation" class="r-1hdp7q5"><path fill-rule="evenodd" d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"></path></svg></button>',
  nextArrow:'<button type="button" class="slick-next pull-right"><svg class="flickity-button-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="1em" height="1em" role="presentation"  class="r-18jbaj6" fill="currentColor"><path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"></path></svg></button>',
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 601,
      settings: {
      slidesToShow: 1,
      slidesToScroll: 1,
      centerMode: true,
      centerPadding: '30px', 
      adaptiveHeight: false
      }
    },
    {
      breakpoint: 480,
      settings: {
      slidesToShow: 1,
      centerMode: true,
      centerPadding: '30px', 
      adaptiveHeight: false
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});
  $('.pr-section-2nd-design .custom-product-reviews-items').slick({
  dots: true,
  adaptiveHeight:true,
  infinite: false,
  speed: 300, 
  prevArrow:'<button type="button" class="slick-prev pull-left"><svg class="flickity-button-icon"  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="1em" height="1em" fill="currentColor" role="presentation" class="r-1hdp7q5"><path fill-rule="evenodd" d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"></path></svg></button>',
  nextArrow:'<button type="button" class="slick-next pull-right"><svg class="flickity-button-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="1em" height="1em" role="presentation"  class="r-18jbaj6" fill="currentColor"><path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"></path></svg></button>',
  slidesToShow: 3.5,
  slidesToScroll: 1,
  cssEase: 'linear',
  responsive: [
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 2.5,
        slidesToScroll: 1,
        infinite: false,
        dots: true
      }
    },
    {
      breakpoint: 801,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 601,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});
  $(".your-wrapper-class").wrapAll("<div class='grid-insta-feed-2'></div>")
  $("variant-selection.variant-selection").on("change", function(){
    var id = $(this).attr("variant");
    $(this).parents("form").find(".subscription-block-item-custom[show-var='"+id+"']").find("input.one-time-box").trigger("click");
    $(this).parents("form").find(".subscription-block-item-custom[show-var='"+id+"']").show();
    $(this).parents("form").find(".subscription-block-item-custom[show-var='"+id+"']").prevAll(".subscription-block-item-custom").hide();
    $(this).parents("form").find(".subscription-block-item-custom[show-var='"+id+"']").nextAll(".subscription-block-item-custom").hide();
    // console.log(id);
    // if ( $("label[variant-id='"+id+"']").length < 1 )
    // {
    //   $(".variant-available").hide();
    // }
    
    // $("label[variant-id='"+id+"']").parents(".variant-available").show();
    // $("label[variant-id='"+id+"']").parents(".variant-available").prevAll(".variant-available").hide();
    // $("label[variant-id='"+id+"']").parents(".variant-available").nextAll(".variant-available").hide();
  })
  $("input[name='purchase_option']").on("change", function(){
    var get = $(this).val();
    console.log(get);
    if ( get == "One time" )
    {
      $("input[name='selling_plan']").val("");
    }
    else
    {
      var id = $(this).parents(".variant-available").find("select").val();
      console.log(id);
      $("input[name='selling_plan']").val(id);
    }
  })
  $("button.bou-now-cstm").on("click", function(){
    $(this).parents(".option").find("input[name='purchase_option']").trigger("click");
    $(this).parents("form").find("button.button.action_button.button--add-to-cart").trigger("click");
  })

  
  $(".product-gallery__thumbnail").on("click", function(){
    $(this).addClass("is-selected");
    $(this).prevAll(".product-gallery__thumbnail").removeClass("is-selected");
    $(this).nextAll(".product-gallery__thumbnail").removeClass("is-selected");
  })
  // $(document).on('click', '.product-custom-product .yotpo.bottomLine.yotpo-small', function() {
  //   const element = document.getElementById("product-review-1-src");
  //   element.scrollIntoView({ block: 'start',  behavior: 'smooth' })
  // })
  
})
$(document).ready(checkContainerr);

function checkContainerr() {
  if($('.yotpo-display-wrapper').is(':visible')){ //if the container is visible on the page
   $(".yotpo-display-wrapper").find("a").attr("href","/pages/product-reviews/")
  } else {
    //console.log("not found");
    setTimeout(checkContainerr, 50); //wait 50 ms, then try again
    
  }
}

// function updateThumbnailSelection(title) {
//   $(".product-gallery__thumbnail").each(function () {
//     const thumbTitle = $(this).data("title");
//     if (thumbTitle === title) {
//       $(this).addClass("is-selected");
//     } else {
//       $(this).removeClass("is-selected");
//     }
//   });
// }

// function getSelectedImageTitle() {
//   const selectedAnchor = $(".product-gallery__main .product-gallery__image.is-selected a");
//   return selectedAnchor.attr("title");
// }

// function runInitialSelection() {
//   const initialTitle = getSelectedImageTitle();
//   if (initialTitle) {
//     updateThumbnailSelection(initialTitle);
//   }
// }

// $(document).ready(function () {
//   // 1. Run on page load
//   runInitialSelection();

//   // 2. Setup MutationObserver for .is-selected class change
//   const observer = new MutationObserver((mutations) => {
//     mutations.forEach((mutation) => {
//       if (mutation.attributeName === "class") {
//         const target = $(mutation.target);
//         if (target.hasClass("is-selected")) {
//           const title = target.find("a").attr("title");
//           if (title) {
//             updateThumbnailSelection(title);
//           }
//         }
//       }
//     });
//   });

//   // Attach observer to all image slides
//   $(".product-gallery__main .product-gallery__image").each(function () {
//     observer.observe(this, {
//       attributes: true,
//       attributeFilter: ["class"]
//     });
//   });
// });
